// RemoveFromCartDrawer.js

import React from 'react';
import './RemoveFromCartDrawer.css'; // 👈 We'll define styles here

const RemoveFromCartDrawer = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="remove-cart-drawer-overlay">
      <div className="remove-cart-drawer">
        <h3>Remove this item from cart</h3>
        <p>Are you sure you want to remove this item?</p>
        <div className="remove-cart-drawer-buttons">
          <button
            className="remove-cart-cancel-btn"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="remove-cart-confirm-btn"
            onClick={onConfirm}
          >
            Remove
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemoveFromCartDrawer;
